import React from "react";
import { Navigate } from "react-router-dom";

import PropertyLayout from "../../mobile/property/PropertyLayout.jsx";
import PropertyList from "../../mobile/property/PropertyList.jsx";
import PropertyContractList from "../../mobile/property/PropertyContractList.jsx";
import PropertyRentCollection from "../../mobile/property/PropertyRentCollection.jsx";
import PropertyIdleHouse from "../../mobile/property/PropertyIdleHouse.jsx";
// import TestUpload from "../../mobile/TestPage.jsx";
const propertyChildren = [
  {
    path: "list",
    element: <PropertyList />,
    handle: {
      sectionMenu: {
        label: "房源",
      },
    },
  },
  {
    path: "contract",
    element: <PropertyContractList />,
    handle: {
      sectionMenu: {
        label: "合同",
      },
    },
  },
  {
    path: "rent",
    element: <PropertyRentCollection />,
    handle: {
      sectionMenu: {
        label: "收租",
      },
    },
  },
  {
    path: "idle",
    element: <PropertyIdleHouse />,
    handle: {
      sectionMenu: {
        label: "空置房",
      },
    },
  },
  // {
  //   path: "test",
  //   element: <TestUpload />,
  //   handle: {
  //     sectionMenu: {
  //       label: "测试",
  //     },
  //   },
  // },
];

const propertyRoutes = {
  path: "property",
  element: <PropertyLayout />,

  handle: {
    section: {
      title: "房产管理",

      menuItems: propertyChildren
        .filter((route) => route.handle?.sectionMenu)
        .map((route) => ({
          path: route.path,
          ...route.handle.sectionMenu,
        })),
    },
  },

  children: [
    {
      index: true,
      element: <Navigate to="list" replace />,
    },
    ...propertyChildren,
  ],
};

export default propertyRoutes;
